/* eslint-disable no-unused-vars */
import React from "react";
import Header from "../Header/header";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import "react-notifications/lib/notifications.css";
import setAuthToken from "../../utils/setAuthToken";
import { setCurrentUser } from "../../actions/authAction";
import jwt_decode from "jwt-decode";
import axios from "axios";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import PropTypes from "prop-types";
import { registerUser } from "../../actions/authAction";
import { state, districts } from "../DataJson/IndianStates.json";
import Footer from "../Footer";
import { countries } from "../../constants/countries";
import ATLCodes from "../../data/atlCodes.json";
import {
  parseTinkerpreneurYear,
  getRegistrationCloseLabel,
  isRegistrationOpen,
} from "../../utils/tinkerpreneur";

const options = [
  { value: 1, label: "Male" },
  { value: 2, label: "Female" },
  { value: 3, label: "Other" },
];

class signUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      states: state,
      districts: districts,
      classname: "6",
      districtName: "",
      selectedState: {},
      isAgreed: false,
      disableBtn: false,
      selectedGender: 1,
      selectedSchoolType: "gov",
      selectedCBSE: "true",
      shouldRedirectToCustomPage: false,
      btnText: "Sign up",
      country: "IN",
      haveAtlLab: "no",
      atlCode: "",
      showAtlError: false,
      invalidAtlCode: false,
    };
  }
  createNotification = (type) => {
    // return () => {
    // eslint-disable-next-line default-case
    switch (type) {
      case "info":
        NotificationManager.info("Info message");
        break;
      case "success":
        NotificationManager.success("Successfully update", "Update");
        break;
      case "warning":
        NotificationManager.warning(
          "Warning message",
          "Close after 3000ms",
          3000
        );
        break;
      case "error":
        NotificationManager.error(
          "Warning message",
          "Account Already exists with this email address",
          7000,
          () => {}
        );
        break;
    }
  };

  changeBtnText = (btnText) => {
    this.setState({ btnText });
  };

  componentDidMount() {
    this.handleGenderChange = this.handleGenderChange.bind(this);
    this.handleSchoolType = this.handleSchoolType.bind(this);
    this.handleSelectedCBSE = this.handleSelectedCBSE.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
  }

  onChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleGenderChange = (event) => {
    this.setState({ selectedGender: event.target.value });
  };

  handleSchoolType = (event) => {
    this.setState({ selectedSchoolType: event.target.value });
  };

  handleSelectedCBSE = (event) => {
    this.setState({ selectedCBSE: event.target.value });
  };

  onSubmit = (e) => {
    e.preventDefault();

    const state =
      this.state.country === "IN" ? this.state.selectedState?.key : "";

    const newUser = {
      first_name: e.target.first_name.value,
      last_name: e.target.last_name.value,
      email_id: e.target.email.value,
      password: e.target.password.value,
      date_of_birth: this.state.date_of_birth,
      school_type: this.state.selectedSchoolType,
      gender: this.state.selectedGender,
      cbse_ai_thon: this.state.selectedCBSE,
      school: e.target.school.value,
      city: e.target.city.value,
      country: this.state.country,
      state: state,
      class: this.state.classname,
      district: this.state.districtName,
      phoneNumber: e.target.phoneNumber.value,
      role: 1,
    };
    const tinkerpreneurYear = parseTinkerpreneurYear(
      this.props.location.search
    );
    const fromTinkerpreneur = tinkerpreneurYear !== null;

    // The form may have been open across the deadline. Re-check at submit time
    // so a page loaded at 11:58 cannot enrol at 12:01. forceUpdate re-renders
    // into the closed branch; no account is created and no enrol call is made.
    if (fromTinkerpreneur && !isRegistrationOpen(tinkerpreneurYear)) {
      this.forceUpdate();
      return;
    }

    if (fromTinkerpreneur) {
      if (
        this.state.haveAtlLab === "" ||
        (this.state.haveAtlLab === "yes" && this.state.atlCode === "")
      ) {
        this.setState({ showAtlError: true });
        return;
      }
      if (this.state.haveAtlLab === "yes") {
        const acceptedAtlCodes = ATLCodes[this.state.selectedState?.key] || [];
        if (!acceptedAtlCodes.includes(this.state.atlCode)) {
          this.setState({ showAtlError: true, invalidAtlCode: true });
          return;
        }
      }
      this.setState({ showAtlError: false, invalidAtlCode: false });
    }

    axios
      .post(`${process.env.REACT_APP_API_URL}/register/student`, newUser)
      .then((res) => {
        const { token, userId } = res.data;
        localStorage.setItem("jwtToken", token);
        localStorage.setItem("studentId", userId);
        setAuthToken(token);
        const decoded = jwt_decode(token);
        this.props.setCurrentUser(decoded);

        if (fromTinkerpreneur) {
          fetch(`${process.env.REACT_APP_API_URL}/atl-tinkerpreneur/enroll`, {
            method: "POST",
            headers: {
              "x-access-token": token,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              year: tinkerpreneurYear,
              haveAtlLab: this.state.haveAtlLab,
              atlCode: this.state.atlCode,
            }),
          }).catch(() => {});
          this.props.history.push(`/tinkerpreneur-${tinkerpreneurYear}`);
        } else {
          this.props.history.push("/dashboard");
        }
      })
      .catch((err) => {
        this.createNotification("error");
        this.props.registerUser(err);
      });
  };

  render() {
    const districtsList =
      this.state.districts[this.state.selectedState.key] || [];
    const tinkerpreneurYear = parseTinkerpreneurYear(
      this.props.location.search
    );
    const fromTinkerpreneur = tinkerpreneurYear !== null;
    const closeLabel = fromTinkerpreneur
      ? getRegistrationCloseLabel(tinkerpreneurYear)
      : null;
    // An edition exists only if it has a REGISTRATION_ENDTIME row. Without one
    // there is nothing true to say about it, so it 404s like its landing page.
    const isKnownEdition = closeLabel !== null;
    const registrationClosed =
      fromTinkerpreneur && !isRegistrationOpen(tinkerpreneurYear);

    if (fromTinkerpreneur && !isKnownEdition) {
      return <Redirect to="/404" />;
    }

    const form = (
      <div className="card login-signup-card shadow-lg mb-0">
        {fromTinkerpreneur && (
          <div className="card-header bg-transparent border-bottom px-md-5 py-3">
            <small>Already have an account? </small>
            <a href="/login" className="small text-blue">
              Sign in
            </a>
          </div>
        )}
        <div className="card-body px-md-5 py-5">
          <form
            className="login-signup-form"
            method="post"
            onSubmit={this.onSubmit}
          >
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "space-evenly",
              }}
            >
              <div className="col-sm-6">
                <div className="form-group">
                  <label className="pb-1">First Name*</label>
                  <div className="input-group input-group-merge">
                    <input
                      value={this.state.first_name}
                      onChange={this.onChange}
                      type="text"
                      name="first_name"
                      className="form-control"
                      placeholder="First Name"
                      pattern="^[a-zA-z\s\.]+$"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form-group col-sm-6">
                <label className="pb-1">Last Name*</label>
                <div className="input-group input-group-merge">
                  <input
                    value={this.state.last_name}
                    onChange={this.onChange}
                    type="text"
                    name="last_name"
                    className="form-control"
                    placeholder="Last name"
                    pattern="^[a-zA-z\s\.]+$"
                    required
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-sm-4">
                <label className="pb-1">
                  Name of your Educational Institution*
                </label>
                <div className="input-group input-group-merge">
                  <input
                    value={this.state.school}
                    onChange={this.onChange}
                    type="text"
                    name="school"
                    className="form-control"
                    placeholder="Name of your Institution"
                    required
                  />
                </div>
              </div>
              <div className="form-group col-sm-4">
                <label className="pb-1">Class*</label>
                <div className="input-group-signup input-group-merge">
                  <select
                    defaultValue={this.state.classname}
                    className="form-control my-0 ml-0"
                    onChange={(event) => {
                      this.setState({ classname: event.target.value });
                    }}
                    required
                  >
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="Higher Education">Higher Education</option>
                  </select>
                </div>
              </div>
              <div className="form-group col-sm-4">
                <label className="pb-1">Institution Type*</label>
                <div className="input-group-signup input-group-merge">
                  <select
                    className="form-control ml-0 my-0"
                    defaultValue={this.state.selectedSchoolType}
                    onChange={this.handleSchoolType}
                  >
                    <option value="gov">Government</option>
                    <option value="private">Private</option>
                    <option value="govtaided">Govt. aided</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-sm-6">
                <label className="pb-1">Email Address*</label>
                <div className="input-group-signup input-group-merge">
                  <input
                    onChange={this.onChange}
                    value={this.state.email}
                    id="email"
                    name="email"
                    type="email"
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                    className="form-control"
                    placeholder="name@yourdomain.com"
                    title="Please enter a valid email address"
                    required
                  />
                </div>
                <small>
                  <span>Don’t have an e-mail account?&nbsp;</span>
                  <a
                    href="https://www.youtube.com/watch?v=koJlF6YDqqA"
                    className="text-blue"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Click here
                  </a>
                  <span>&nbsp;to know how to create one!</span>
                </small>
              </div>
              <div className="form-group col-sm-6">
                <label className="pb-1">Password*</label>
                <div className="input-group-signup input-group-merge">
                  <input
                    value={this.state.password}
                    onChange={this.onChange}
                    type="password"
                    name="password"
                    className="form-control"
                    placeholder="Enter a new password for AISC"
                    required
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-sm-6">
                <label className="pb-1">Phone Number</label>
                <div className="input-group input-group-merge">
                  <input
                    value={this.state.phoneNumber}
                    onChange={this.onChange}
                    type="text"
                    name="phoneNumber"
                    className="form-control"
                    placeholder="Phone Number"
                    maxLength={10}
                    pattern="\d+"
                  />
                </div>
              </div>
              <div className="form-group col-sm-6">
                <label className="pb-1">Gender*</label>
                <div className="input-group-signup input-group-merge">
                  <select
                    defaultValue={this.state.selectedGender}
                    className="form-control my-0 ml-0"
                    onChange={this.handleGenderChange}
                    required
                  >
                    <option value="1">Male</option>
                    <option value="2">Female</option>
                    <option value="3">Other</option>
                  </select>
                </div>
              </div>

              <div className={"form-group col-sm-6"}>
                <label className="pb-1">Nearest City*</label>
                <div className="input-group-signup input-group-merge">
                  <input
                    value={this.state.city}
                    onChange={this.onChange}
                    type="text"
                    name="city"
                    className="form-control"
                    placeholder="Nearest City"
                    required
                  />
                </div>
              </div>
              {this.state.country === "IN" && (
                <>
                  <div className="form-group col-sm-6">
                    <label className="pb-1">State/UT*</label>
                    <div className="input-group-signup input-group-merge">
                      <select
                        className="form-control ml-0 my-0"
                        value={this.state.selectedState.key}
                        onChange={(event) => {
                          const selectedState = this.state.states.find(
                            (state) => state.key === event.target.value
                          );
                          this.setState({ selectedState: selectedState });
                        }}
                        required
                      >
                        <option value="">Select State/UT</option>
                        {this.state.states.map((state, index) => (
                          <option value={state.key} key={index}>
                            {state.value}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-group col-sm-6">
                    <label className="pb-1">District*</label>
                    <div className="input-group-signup input-group-merge">
                      <select
                        className="form-control ml-0 my-0"
                        value={this.state.districtName}
                        onChange={(event) =>
                          this.setState({ districtName: event.target.value })
                        }
                        required
                      >
                        <option value="">Select District</option>
                        {districtsList.map((district, index) => (
                          <option value={district} key={index}>
                            {district}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className={"form-group col-sm-6"}>
                    <label className="pb-1">Country*</label>
                    <div className="input-group-signup input-group-merge">
                      <select
                        className="form-control ml-0 my-0"
                        value={this.state.country}
                        onChange={(event) =>
                          this.setState({ country: event.target.value })
                        }
                        required
                      >
                        <option value="">Select Country</option>
                        {countries.map((country, index) => (
                          <option
                            value={country.key}
                            key={index}
                            dangerouslySetInnerHTML={{ __html: country.value }}
                          />
                        ))}
                      </select>
                    </div>
                  </div>
                </>
              )}
            </div>
            {fromTinkerpreneur && (
              <div className="row mx-0 mt-4">
                <div className="col-12 mb-3">
                  <label className="d-block mb-2 font-weight-bold">
                    Does your school have ATL Lab?
                  </label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="hasAtlLab"
                      value="yes"
                      id="atlLabYes"
                      onChange={(e) =>
                        this.setState({
                          haveAtlLab: e.target.value,
                          atlCode: "",
                        })
                      }
                    />
                    <label className="form-check-label" htmlFor="atlLabYes">
                      Yes
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="hasAtlLab"
                      value="no"
                      id="atlLabNo"
                      defaultChecked
                      onChange={(e) =>
                        this.setState({
                          haveAtlLab: e.target.value,
                          atlCode: "",
                        })
                      }
                    />
                    <label className="form-check-label" htmlFor="atlLabNo">
                      No
                    </label>
                  </div>
                  <div className="text-danger small mt-1">
                    {this.state.showAtlError &&
                      this.state.haveAtlLab === "" &&
                      "Please choose an option."}
                  </div>
                </div>
                {this.state.haveAtlLab === "yes" && (
                  <div className="col-12 mb-3">
                    <label className="d-block mb-2">
                      ATL Code (
                      <small>
                        <a
                          href="/assets/pdf/OperationalATLsInIndia.pdf"
                          style={{ color: "#0048ff" }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Click here
                        </a>
                        <span>&nbsp;to know ATL code!</span>
                      </small>
                      )
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="ATL Code"
                      value={this.state.atlCode}
                      onChange={(e) =>
                        this.setState({ atlCode: e.target.value })
                      }
                    />
                    <small className="text-danger">
                      {this.state.showAtlError &&
                        this.state.atlCode === "" &&
                        "ATL Code is required. "}
                      {this.state.invalidAtlCode &&
                        this.state.showAtlError &&
                        "Invalid ATL Code. Please fill a valid ATL Code."}
                    </small>
                  </div>
                )}
              </div>
            )}
            <div className="row mx-0 mt-5">
              <div
                className="col-12 mb-3 px-3 py-2 rounded"
                style={{
                  backgroundColor: "#fff8e1",
                  border: "1px solid #ffe082",
                  fontSize: "0.85rem",
                  color: "#5a4a00",
                }}
              >
                <strong>Reminder:</strong> Please ensure that your profile is
                updated.
              </div>
              <div className="col-12 text-center">
                <button
                  className="btn-theme-primary mx-auto text-center px-5 signup-btn"
                  id="signIn"
                  disabled={this.state.disableBtn}
                  onClick={() => {
                    this.changeBtnText("Signing Up...");
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
        <div className="card-footer px-md-5 py-2 bg-transparent border-top d-block d-lg-flex justify-content-between">
          <div>
            <small>Already have an account? </small>
            <a href="/login" className="small text-blue">
              Sign in
            </a>
          </div>
          <div style={{ color: "#1a2b4b" }}>
            AISC is a student community of practice, run by students.
          </div>
        </div>
      </div>
    );

    return (
      <React.Fragment>
        {!fromTinkerpreneur && <Header />}
        <NotificationContainer />
        <div className={fromTinkerpreneur ? "" : "pt-265p pt-md-200p"}>
          {fromTinkerpreneur && (
            <img
              src={`/images/tinkerpreneur-${tinkerpreneurYear}/form-header.png`}
              alt={`India AI Tinkerpreneur ${tinkerpreneurYear} sponsors`}
              className="w-100 d-block"
            />
          )}
          <section className="page-signup pt-30 pb-50">
            <div className="container">
              <div className="col-md-12 col-lg-12 ">
                {registrationClosed ? (
                  <p className="page-title text-center my-5">
                    {`Registrations for India AI Tinkerpreneur ${tinkerpreneurYear} closed on ${closeLabel}.`}
                  </p>
                ) : (
                  <>
                    <div>
                      <h3 className="page-title">Sign up</h3>
                      <p style={{ textAlign: "center" }}>
                        Complete the form below to sign up for the community
                      </p>
                    </div>
                    {form}
                  </>
                )}
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

signUp.propTypes = {
  registerUser: PropTypes.func.isRequired,
  setCurrentUser: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  // auth: PropTypes.object.isRequired,
  // errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    error: state.authFail.error,
  };
};

export default connect(mapStateToProps, { registerUser, setCurrentUser })(
  withRouter(signUp)
);
